/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteResetUserPermissionMutationResponse, UsersAuthzAPIAdminPermissionsWriteResetUserPermissionPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteResetUserPermission";

function getUsersAuthzAPIAdminPermissionsWriteResetUserPermissionUrl(userId: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionPathParams["permission"]) {
  const res = { method: 'POST', url: `/admin/user/${userId}/permissions/${permission}/reset` as const }  
  return res
}

/**
 * @summary Reset a permission for a user
 * {@link /admin/user/:userId/permissions/:permission/reset}
 */
export async function usersAuthzAPIAdminPermissionsWriteResetUserPermission(userId: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionPathParams["permission"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIAdminPermissionsWriteResetUserPermissionMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getUsersAuthzAPIAdminPermissionsWriteResetUserPermissionUrl(userId, permission).url.toString(), ... requestConfig })  
  return res.data
}